__turbopack_context__.v({
  "link": "PlasmicMobileDrawerItemSubItem-module__iPPgoa__link",
  "submenuItem": "PlasmicMobileDrawerItemSubItem-module__iPPgoa__submenuItem",
  "submenuItemactive": "PlasmicMobileDrawerItemSubItem-module__iPPgoa__submenuItemactive",
  "text": "PlasmicMobileDrawerItemSubItem-module__iPPgoa__text",
});
